import { useGlobalStore } from '../index';

import type { GlobalStore } from '../index';

// SETTERS
export const setUserRoles = useGlobalStore.getState().setUserRoles;

// GETTERS
export const getUserRoles = (store: GlobalStore) => {
  const { userRoles } = store;
  return userRoles;
};
